﻿import * as angular from "angular";

Reflect.set(globalThis, "WaitIndex", 0);

angular.module("datastore", []);
